import { render } from "./create_visit.vue?vue&type=template&id=1c76f040&scoped=true"
import script from "./create_visit.vue?vue&type=script&lang=js"
export * from "./create_visit.vue?vue&type=script&lang=js"

import "./create_visit.vue?vue&type=style&index=0&id=1c76f040&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c76f040"]])

export default __exports__